export const SPRING_CONFIG = {
  mass: 0,
  friction: 100,
  tension: 50,
  clamp: false
};
